import React from 'react';

import { CheckOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RetrieveUserGroupSchema } from '@app/models/users';

import { useGroups } from '../../../../providers';
import { NEW_GROUP_ID } from '../../../../providers/constants';

import { EditableContext } from '../EditableContext';

interface IProps {
  record: RetrieveUserGroupSchema;
}

export const SaveAction: React.FC<IProps> = ({ record }) => {
  const form = React.useContext(EditableContext);
  const commonT = useTranslation(NSKeys.common);
  const { editingRowKey } = useGroups();

  if (editingRowKey !== record.uid) {
    return null;
  }

  return (
    <Tooltip title={commonT.t('buttonSave')}>
      <Button type="link" icon={<CheckOutlined />} onClick={() => form?.submit()} />
    </Tooltip>
  );
};
